import { baseUrl } from "./config";

const activateStaffById = (id) => `${baseUrl}users/reactivateStaff/${id}`;
const checkClientDuplicates = `${baseUrl}clients/check-duplicates`;
const checkStaffInvite = `${baseUrl}users/checkStaffInvite`;
const createClient = `${baseUrl}clients`;
const createUser = `${baseUrl}users/createUser`;
const createVisit = `${baseUrl}visits`;
const deactivateStaffById = (id) => `${baseUrl}users/deactivateStaff/${id}`;
const editUserById = (id) => `${baseUrl}users/editUser/${id}`;
const getClientById = (id) => `${baseUrl}clients/${id}`;
const getClients = `${baseUrl}clients`;
const getDashboardMetrics = `${baseUrl}dashboard/metrics`;
const getSuperAdminActivityLogById = (id) => `${baseUrl}admin/super/activity-logs/${id}`;
const getSuperAdminActivityLogs = `${baseUrl}admin/super/activity-logs`;
const getSuperAdminMetrics = `${baseUrl}admin/super/metrics`;
const getSuperAdminOrganizationById = (id) => `${baseUrl}admin/super/organizations/${id}`;
const updateSuperAdminOrganizationById = (id) => `${baseUrl}admin/super/organizations/${id}`;
const updateSuperAdminOrganizationStatusById = (id) => `${baseUrl}admin/super/organizations/${id}/status`;
const impersonateSuperAdminOrganizationAdminById = (id) => `${baseUrl}admin/super/organizations/${id}/impersonate`;
const getSuperAdminOrganizations = `${baseUrl}admin/super/organizations`;
const createSuperAdminOrganization = `${baseUrl}admin/super/organizations`;
const getSuperAdminUserById = (accountType, id) => `${baseUrl}admin/super/users/${accountType}/${id}`;
const getSuperAdminUsers = `${baseUrl}admin/super/users`;
const getUserById = (id) => `${baseUrl}users/getUser/${id}`;
const getUsers = `${baseUrl}users/getUsers`;
const getValidationMetrics = `${baseUrl}validation/metrics`;
const getValidationRecordById = (id) => `${baseUrl}validation/records/${id}`;
const getValidationRecords = `${baseUrl}validation/records`;
const getValidationImportDetails = (runId) => `${baseUrl}validation/imports/${runId}`;
const getValidationUploads = `${baseUrl}validation/uploads`;
const getActiveValidationImportRun = `${baseUrl}validation/import-runs/active`;
const getValidationImportRun = (runId) => `${baseUrl}validation/import-runs/${runId}`;
const previewValidationCsv = `${baseUrl}validation/preview`;
const startValidationImport = `${baseUrl}validation/import`;
const uploadValidationCsv = `${baseUrl}validation/upload`;
const getVisitById = (id) => `${baseUrl}visits/${id}`;
const getVisits = `${baseUrl}visits`;
const resendInvitationById = (id) => `${baseUrl}users/resendInvitation/${id}`;
const sendPasswordResetById = (id) => `${baseUrl}users/sendPasswordReset/${id}`;
const updateClientById = (id) => `${baseUrl}clients/${id}`;

export {
	activateStaffById,
	checkClientDuplicates,
	checkStaffInvite,
	createClient,
	createUser,
	createVisit,
	deactivateStaffById,
	editUserById,
	getClientById,
	getClients,
	getDashboardMetrics,
	getSuperAdminActivityLogById,
	getSuperAdminActivityLogs,
	getSuperAdminMetrics,
	getSuperAdminOrganizationById,
	createSuperAdminOrganization,
	getSuperAdminOrganizations,
	impersonateSuperAdminOrganizationAdminById,
	getSuperAdminUserById,
	getSuperAdminUsers,
	getUserById,
	getUsers,
	getValidationMetrics,
	getValidationRecordById,
	getValidationRecords,
	getValidationImportDetails,
	getValidationUploads,
	getActiveValidationImportRun,
	getValidationImportRun,
	previewValidationCsv,
	startValidationImport,
	getVisitById,
	getVisits,
	resendInvitationById,
	sendPasswordResetById,
	updateClientById,
	updateSuperAdminOrganizationById,
	updateSuperAdminOrganizationStatusById,
	uploadValidationCsv,
};
